import { Scissors } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { FOOTER_COLUMNS } from './footerLinks';
import { LanguageSwitcher } from './LanguageSwitcher';

/** Public site footer with the sitemap-style link columns. */
export const SiteFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full border-t border-gray-800 bg-darker py-16">
      <div className="container-page">
        <div className="mb-16 grid grid-cols-2 gap-12 md:grid-cols-5">
          <div className="col-span-2 space-y-6">
            <div className="flex items-center gap-2 text-white">
              <div className="rounded-lg bg-primary/20 p-2">
                <Scissors size={24} className="text-primary" />
              </div>
              <span className="font-heading text-2xl font-bold tracking-tight">{t('brand')}</span>
            </div>
            <p className="max-w-sm leading-relaxed text-gray-400">{t('footer.tagline')}</p>
          </div>

          {FOOTER_COLUMNS.map(({ titleKey, links }) => (
            <div key={titleKey}>
              <h2 className="mb-6 font-heading font-bold tracking-wide text-white">
                {t(titleKey)}
              </h2>
              <ul className="space-y-4">
                {links.map(({ to, labelKey }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      className="text-sm text-gray-400 transition-colors hover:text-white"
                    >
                      {t(labelKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-gray-800 pt-8 md:flex-row">
          <p className="text-sm text-gray-400" suppressHydrationWarning>
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            {/* Social links are not wired up yet — placeholders keep the layout. */}
            {[0, 1, 2].map((index) => (
              <div
                key={index}
                className="h-8 w-8 rounded-full bg-gray-800 transition-colors hover:bg-gray-700"
              />
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
